export const ClipboardIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '18'}
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3335 3.33073H15.0002C15.4422 3.33073 15.8661 3.50632 16.1787 3.81888C16.4912 4.13145 16.6668 4.55537 16.6668 4.9974V16.6641C16.6668 17.1061 16.4912 17.53 16.1787 17.8426C15.8661 18.1551 15.4422 18.3307 15.0002 18.3307H5.00016C4.55814 18.3307 4.13421 18.1551 3.82165 17.8426C3.50909 17.53 3.3335 17.1061 3.3335 16.6641V4.9974C3.3335 4.55537 3.50909 4.13145 3.82165 3.81888C4.13421 3.50632 4.55814 3.33073 5.00016 3.33073H6.66683M7.50016 1.66406H12.5002C12.9604 1.66406 13.3335 2.03716 13.3335 2.4974V4.16406C13.3335 4.6243 12.9604 4.9974 12.5002 4.9974H7.50016C7.03993 4.9974 6.66683 4.6243 6.66683 4.16406V2.4974C6.66683 2.03716 7.03993 1.66406 7.50016 1.66406Z"
      stroke={props?.color || '#101828'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
